import React, { useState } from "react";
import { motion } from "framer-motion";
import spacings from "../../theme/spacings";
import { useTheme } from "../../providers/theme-provider";
import { fontSizes } from "../../theme/font-sizes";
import { assetIcons } from "../../constants/assets";
import useWindowSize from "../../hooks/use-window-size";
import { useTranslation } from "react-i18next";

const FAQSection = () => {
  const { t } = useTranslation();
  const { width } = useWindowSize();
  const isMobile = width < 768;

  const paddingTopBottom = isMobile
    ? spacings.mobileTopBottomPagePadding
    : spacings.topBottomPagePadding;
  const paddingLeftRight = isMobile
    ? spacings.mobileLeftRightPagePadding
    : spacings.leftRightPagePadding;

  const { colors } = useTheme();
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div
      className="flex flex-col gap-8"
      style={{
        padding: `${paddingTopBottom}px ${paddingLeftRight}px`,
        backgroundColor: colors.background,
      }}
      id="faq"
    >
      <h3
        style={{
          fontSize: fontSizes.heading3,
          color: colors.menuText,
        }}
        className="text-center font-bold"
      >
        {t("faq.sectionTitle")}
      </h3>

      <div className="w-full max-w-full mx-auto flex flex-col gap-4">
        {t("faq.items", { returnObjects: true }).map((item, index) => (
          <motion.div
            key={index}
            whileInView={{ opacity: 1, y: 0 }}
            initial={{ opacity: 0, y: 20 }}
            transition={{
              duration: 0.5,
              ease: "easeInOut",
              delay: index * 0.1,
            }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <motion.button
              onClick={() => toggleAccordion(index)}
              className="w-full flex justify-between items-center gap-6 transition-colors duration-300"
              aria-expanded={openIndex === index}
              style={{
                backgroundColor: colors.demoBg,
                padding: spacings.faqPadding,
              }}
              whileHover={{ scale: 1.02 }}
            >
              <span
                className="text-left font-semibold"
                style={{
                  fontSize: fontSizes.body,
                  color: colors.menuText,
                }}
              >
                {item.title}
              </span>

              <motion.img
                src={assetIcons.chevDown}
                alt=""
                className={`transition-transform duration-300 w-4 ${
                  openIndex === index ? "rotate-180" : ""
                }`}
                animate={{ rotate: openIndex === index ? 180 : 0 }}
                transition={{ duration: 0.3 }}
              />
            </motion.button>

            <motion.div
              initial={false}
              animate={{ height: openIndex === index ? "auto" : 0 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              style={{
                overflow: "hidden",
              }}
            >
              <motion.div
                className="p-4"
                style={{
                  fontSize: fontSizes.titleText,
                  color: colors.menuText,
                  backgroundColor: colors.background,
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: openIndex === index ? 1 : 0 }}
                transition={{ duration: 0.3 }}
              >
                {item.content}
              </motion.div>
            </motion.div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;
